<template>
    <div v-if="!$store.state.isMobile">
        <p style="margin-top: 137px"></p>
        <p class="divider"></p>
        <div class="bottomNav">
            <div class="nav">
                <div class="ico">
                    <img src="@/assets/img/bottom/Pricetag.svg" alt="">
                </div>
                <h4>{{ langPage['home']['TXT_pqefpwholesaletitle'] }}</h4>
                <h5>{{ langPage['v4-bottomnav']['TXT_plusde3000parsemaine'] }}</h5>
            </div>
            <div class="nav">
                <div class="ico">
                    <img src="@/assets/img/bottom/Delivery.svg" alt="">
                </div>
                <h4>{{ langPage['landingpage']['TXT_avantagessstitre3'] }}</h4>
                <h5>{{ langPage['v4-bottomnav']['TXT_expeditiondansles48h'] }}</h5>
            </div>
            <div class="nav" @click="$router.push('/help')">
                <div class="ico">
                    <img src="@/assets/img/bottom/User.svg" alt="">
                </div>
                <h4>{{ langPage['v4-bottomnav']['TXT_serviceclientautop'] }}</h4>
                <h5>{{ langPage['v4-bottomnav']['TXT_lapourvousaider'] }}</h5>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="mBottomNav mobileCommon" align="center">
            <div class="mdivider"></div>
            <div class="ico" style="margin-top: 30px;">
                <img src="@/assets/img/bottom/Pricetag.svg" alt="">
            </div>
            <h4>{{ langPage['home']['TXT_pqefpwholesaletitle'] }}</h4>
            <h5>{{ langPage['v4-bottomnav']['TXT_plusde3000parsemaine'] }}</h5>

            <div class="ico">
                <img src="@/assets/img/bottom/Delivery.svg" alt="">
            </div>
            <h4>{{ langPage['landingpage']['TXT_avantagessstitre3'] }}</h4>
            <h5>{{ langPage['v4-bottomnav']['TXT_expeditiondansles48h'] }}</h5>

            <div class="ico" @click="$router.push('/help')">
                <img src="@/assets/img/bottom/User.svg" alt="">
            </div>
            <h4>{{ langPage['v4-bottomnav']['TXT_serviceclientautop'] }}</h4>
            <h5>{{ langPage['v4-bottomnav']['TXT_lapourvousaider'] }}</h5>
        </div>
    </div>
</template>

<script>
export default {
    name: "bottomNav",
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    }
}

</script>

<style scoped lang="less">

.divider {
    background: #DCDFE6;
    height: 1px;
    width: 100vw;
    position: absolute;
    left: 0;
}


.mdivider {
    background: #DCDFE6;
    height: 1px;
    width: 100%;
}


.bottomNav {
    padding: .4rem 0vw;
    text-align: center;
    display: flex;
    width: 100%;
    justify-content: space-evenly;

    .nav {

        .ico {
            width: 41px;
            height: 41px;
            vertical-align: middle;
            margin: 0 auto;
            margin-bottom:30px;

            img {
                width: 100%;
                vertical-align: middle;
            }
        }

        h4 {
            font-size: 14px;
            font-family: MaisonNeue-Medium;
            margin-bottom:10px;
            flex-wrap: nowrap;
        }

        h5 {
            font-size: 14px;
            font-family: MaisonNeue-Light;
        }
    }
}

.mBottomNav {
    text-align: center;
    //position: relative;

    .ico {
        margin-bottom: 20px;
        display: inline-block;

        img {
            width: 10vw;
        }
    }

    h4 {
        font-size: 10pt;
        font-family: MaisonNeue-Medium;
        margin-bottom: 10px;
    }

    h5 {
        font-size: 10pt;
        font-family: MaisonNeue-Light;
        padding-bottom: 40px;
    }
}
</style>


